<script>
export default {
  name: 'AtendimentoVisaoToggle',
  props: {
    visao: { type: String, default: 'kanban' },
  },
  emits: ['change'],
  methods: {
    selecionar(visao) {
      if (visao === this.visao) return;
      this.$emit('change', visao);
    },
  },
};
</script>

<template>
  <div class="btn-group btn-group-sm atendimento-visao-toggle" role="group" aria-label="Alternar visualização">
    <button
      type="button"
      class="btn"
      :class="visao === 'kanban' ? 'btn-primary' : 'btn-outline-primary'"
      @click="selecionar('kanban')"
    >
      <i class="ri-layout-grid-line me-1"></i>Kanban
    </button>
    <button
      type="button"
      class="btn"
      :class="visao === 'lista' ? 'btn-primary' : 'btn-outline-primary'"
      @click="selecionar('lista')"
    >
      <i class="ri-list-check me-1"></i>Lista
    </button>
  </div>
</template>

<style scoped>
.atendimento-visao-toggle {
  flex-wrap: nowrap;
}

.atendimento-visao-toggle .btn {
  white-space: nowrap;
}
</style>
